module.exports = __webpack_public_path__ + "static/media/archiveIStoryName.cdc59e6e.png";